module.exports = __webpack_public_path__ + "img/hualianwang.9c902f92.png";